import React from 'react';
import PropTypes from 'prop-types';
import {
  MAP_PIN_PRIMARY_HEIGHT_PX,
  MAP_PIN_PRIMARY_WIDTH_PX,
} from '../../../../modules/theme/map';

// Left Below Line Commented on Purpose
// const MAP_PIN_SOLID = 'M22,11c0,6.08-11,19-11,19S0,17.08,0,11a11,11,0,0,1,22,0Z';

const propTypes = {
  color: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

const MapPin = ({
  color,
  id,
  onClick,
  style,
  text,
  textColor,
  ...rest
}) => {
  const svgStyle = {
    height: `${MAP_PIN_PRIMARY_HEIGHT_PX}px`,
    width: `${MAP_PIN_PRIMARY_WIDTH_PX}px`,
    ...style,
  };
  return (
    <svg
      {...rest}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="map-pin-primary"
      onClick={onClick}
      style={svgStyle}
      viewBox="0 0 22 30"
    >
      <g>
        <path
          d="M11,0A11,11,0,0,0,0,11c0,6.08,11,19,11,19S22,17.08,22,11A11,11,0,0,0,11,0Z"
          data-testid="map-pin-secondary-background"
          fill="#FFF"
          stroke="#FFF"
          strokeWidth={0.5}
        />
        <path
          d="M11,0A11,11,0,0,0,0,11c0,6.08,11,19,11,19S22,17.08,22,11A11,11,0,0,0,11,0Zm0,14.79a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,11,14.79Z"
          data-testid="map-pin-secondary-bg"
          fill={color}
          stroke="#FFF"
          strokeWidth={0.5}
        />
      </g>
      {text && (
        <text
          data-testid="map-pin-secondary-label"
          fill={textColor}
          textAnchor="middle"
          x="50%"
          y="16"
        >
          {text}
        </text>
      )}
    </svg>
  );
};

propTypes.propTypes = propTypes;

export default MapPin;
